import React, { PropsWithChildren, ReactNode } from "react";
import "./GenAIButton.css";

interface CustomButtonProps {
  icon?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  isActive?: boolean;
  dataTestId?: string;
  ariaLabel?: string;
  type?: "pill" | "icon";
}

export const GenAIButton = ({
  icon,
  onClick,
  disabled = false,
  isActive = false,
  dataTestId = "genAIButton",
  ariaLabel,
  type = "pill",
  children,
}: PropsWithChildren<CustomButtonProps>) => {
  const className = ["gen-ai-button", `type-${type}`, `${isActive && !disabled ? "active" : ""}`].join(" ").trim();

  return (
    <button className={className} onClick={onClick} disabled={disabled} data-testid={dataTestId} aria-label={ariaLabel}>
      {icon && <span className="icon">{icon}</span>}
      {children}
    </button>
  );
};
